<sw-page class="topdata-reg-attempt-log-detail">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.regLog.detail.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button @click="$router.push({ name: 'topdata.contact.login.reg.log.list' })">
            {{ $tc('global.default.back') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card-group v-if="item">
            <sw-card :title="$tc('TopdataContactLoginSW6.regLog.detail.card.logInfo')">
                <sw-description-list>
                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.email') }}</dt>
                    <dd>{{ item.email }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.attemptType') }}</dt>
                    <dd>{{ getAttemptTypeLabel(item.attemptType) }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.conflictType') }}</dt>
                    <dd>
                        <sw-badge :variant="getConflictTypeVariant(item.conflictType)">
                            {{ getConflictTypeLabel(item.conflictType) }}
                        </sw-badge>
                    </dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.createdAt') }}</dt>
                    <dd>
                {# {{ formatDate(item.createdAt) }} / #}
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
                    </dd>

                    <template v-if="item.ipAddress">
                        <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.ipAddress') }}</dt>
                        <dd>{{ item.ipAddress }}</dd>
                    </template>

                    <template v-if="item.userAgent">
                        <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.userAgent') }}</dt>
                        <dd class="reg-attempt-log-user-agent">{{ item.userAgent }}</dd>
                    </template>
                </sw-description-list>
            </sw-card>

            <sw-card
                v-if="item.customer"
                :title="$tc('TopdataContactLoginSW6.regLog.detail.card.customerInfo')"
            >
                <sw-description-list>
                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.customerName') }}</dt>
                    <dd>{{ item.customer.firstName }} {{ item.customer.lastName }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.regLog.detail.label.customerEmail') }}</dt>
                    <dd>{{ item.customer.email }}</dd>
                </sw-description-list>
            </sw-card>
        </sw-card-group>

        <sw-loader v-else-if="isLoading" />

        <sw-empty-state
            v-else
            :title="$tc('TopdataContactLoginSW6.regLog.detail.notFound')"
        />
    </template>
</sw-page>
